const resources = {
    signInFree: 'Sign In for FREE Shipping',
    signInAccount: 'Don’t have an account?',
    signInAccountLink: 'Create an account',
    signInCTA: 'Sign In',
    status: 'You’re a',
    points: 'with',
    join: 'Join Beauty Insider',
    earn: 'to earn points with every purchase.',
    ccRewards: 'Credit Card Rewards',
    signInForPrefix: 'Sign in for',
    fastFreeShipping: 'FAST FREE Shipping',
    allOrders: 'on all orders',
    noMinSpend: 'with no min spend',
    newHere: 'New here?',
    joinNow: 'Join Now'
};

export default function getResource(label) {
    return resources[label];
}
